import { useEffect, useState } from 'react';

const RELEASE_TIMEOUT_MS = 3000;
const SKELETON_DELAY_MS = 200;

export type AppShellGate = {
  isGated: boolean;
  showSkeleton: boolean;
};

export const useAppShellGate = (isSettled: boolean): AppShellGate => {
  const [timedOut, setTimedOut] = useState(false);
  const [delayElapsed, setDelayElapsed] = useState(false);

  useEffect(() => {
    if (isSettled) return;

    const releaseTimer = setTimeout(() => setTimedOut(true), RELEASE_TIMEOUT_MS);
    const skeletonTimer = setTimeout(() => setDelayElapsed(true), SKELETON_DELAY_MS);
    return () => {
      clearTimeout(releaseTimer);
      clearTimeout(skeletonTimer);
    };
  }, [isSettled]);

  const isGated = !isSettled && !timedOut;

  return { isGated, showSkeleton: isGated && delayElapsed };
};
